export default {
    "navigation": {
        "allWatchfaces": "Alle apper",
        "faq": "FAQ",
        "helpCenter": "Hjelp og instruksjoner",
        "newsletter": "Nyhetsbrev",
        "contact": "Kontakt",
        "weatherProvider": "Værleverandør",
        "tides": "Tidevann",
        "colors": "Farger",
        "fonts": "Skrifttyper"
    },
    "homepage": {
        "title": "TitanicTurtle Apps",
        "subtitle": "Moderne Garmin-apper med avanserte funksjoner for alle aktivitetene dine",
        "features": {
            "tides": "🌊 Tidevann",
            "weather": "🌤️ Vær",
            "themes": "🎨 Fargetemaer",
            "gps": "📍 GPS"
        },
        "availableWatchfaces": "Tilgjengelige urskiver",
        "newBadge": "Ny",
        "loading": "Laster urskiver …",
        "error": "Feil ved lasting",
        "retry": "Prøv igjen",
        "filter": {
            "label": "Produktfilter",
            "watchfaces": "Urskiver",
            "apps": "Apper",
            "all": "Alle",
            "noProducts": "Ingen produkter i denne kategorien"
        }
    },
    "watchface": {
        "purchase": "Kjøp nå",
        "buy": "Kjøp",
        "features": "Funksjoner",
        "colorThemes": "Fargetemaer",
        "themeDescription": "Klikk på et tema for å kopiere temastrengen og bruke den i urskivinnstillingene.",
        "dynamicThemeSwitching": "Dynamisk temabytte",
        "sunsetSwitching": {
            "title": "🌅 Etter solnedgang / før soloppgang",
            "description": "Sett et utropstegn ! foran temastrengen for automatisk bytte etter solnedgang (eksempel: !UEUE[UEUEEEEEEU^)."
        },
        "lowPowerSwitching": {
            "title": "🔋 I lavstrømsmodus",
            "description": "Sett et # foran temastrengen for lavstrømsmodus (eksempel: #UEUE[UEUEEEEEEU^)."
        },
        "themeCopied": "Temastreng kopiert til utklippstavlen!",
        "viewDetails": "Vis detaljer"
    },
    "faq": {
        "title": "Ofte stilte spørsmål",
        "subtitle": "Finn svar på vanlige spørsmål om urskivene våre",
        "tabs": {
            "search": "Søk",
            "categories": "Kategorier",
            "all": "Vis alle FAQ"
        },
        "category": {
            "selected": "Valgt kategori",
            "showing": "Viser",
            "items": "elementer",
            "from": "av",
            "clear": "Fjern valg",
            "back": "Tilbake til kategorier"
        },
        "viewAnswer": "Vis svar",
        "closeAnswer": "Lukk svar",
        "darkMode": {
            "enable": "Aktiver mørk modus",
            "disable": "Deaktiver mørk modus",
            "light": "Lys",
            "dark": "Mørk"
        },
        "search": {
            "placeholder": "Søk etter hjelp …",
            "button": "Søk",
            "suggestions": "Populære søk",
            "tips": {
                "title": "Søketips",
                "keywords": "Bruk spesifikke nøkkelord som «GPS», «vær» eller «innstillinger»",
                "language": "Søket fungerer på valgt språk",
                "categories": "Bla gjennom kategorier for organisert hjelp"
            }
        },
        "noResults": {
            "title": "Ingen resultater funnet",
            "description": "Prøv andre nøkkelord eller bla gjennom kategorier",
            "browseCategories": "Bla gjennom kategorier"
        },
        "suggestions": {
            "title": "Populære søk"
        },
        "trending": {
            "title": "Populære søk akkurat nå"
        },
        "categories": {
            "title": "Bla etter kategori",
            "items": "elementer",
            "allItems": "Alle FAQ-elementer",
            "allItemsDescription": "Bla gjennom alle ofte stilte spørsmål",
            "noItems": {
                "title": "Ingen elementer i denne kategorien",
                "description": "Prøv å velge en annen kategori"
            },
            "viewMore": "Vis alle elementer"
        },
        "results": {
            "title": "Søkeresultater",
            "found": "resultater funnet for",
            "total": "Totalt antall resultater",
            "bestMatch": "Beste treff",
            "categories": "Kategorier",
            "sortBy": "Sorter etter",
            "sort": {
                "relevance": "Relevans",
                "priority": "Prioritet",
                "category": "Kategori"
            },
            "lastUpdated": "Sist oppdatert",
            "matchedIn": "Treff i",
            "footer": "Fant du ikke det du lette etter?",
            "browseCategories": "Bla gjennom kategorier",
            "viewTrending": "Vis populære søk",
            "contactSupport": "Kontakt support"
        },
        "actions": {
            "copy": "Kopier",
            "share": "Del",
            "copyAnswer": "Kopier svar",
            "copyAll": "Kopier alt"
        },
        "loading": "Laster FAQ …",
        "error": "Feil ved lasting",
        "retry": "Prøv igjen",
        "questions": {
            "gpsFix": {
                "question": "Hva er en GPS-fix, og hvordan gjør jeg det? / Hvorfor viser noen alternativer «GPS?»",
                "answer": "En GPS-fix trengs for at urskiven skal vite hvor du er, slik at alt knyttet til sol- og månetider beregnes riktig.\n\nDu kan gjøre en GPS-fix ved å starte en aktivitet og vente til klokken har GPS-signal, eller ved å holde inne GPS-knappen til klokken har signal.\n\nDeretter kan du gå tilbake til urskiven – alt skal vises riktig."
            },
            "userData": {
                "question": "Samler urskivene inn brukerdata?",
                "answer": "Ingen TitanicTurtle-urskiver samler inn brukerdata eller sender dem videre. De viser bare data fra Garmin eller beregner ut fra dem (f.eks. aktive kalorier).\n\nGenerelt er data Garmin gir til tredjepartsurskiver ikke personlige – det finnes f.eks. ikke navn å lese ut."
            },
            "permissions": {
                "question": "Hvorfor trenger urskivene så mange tillatelser?",
                "answer": "TitanicTurtle Watchfaces trenger tillatelser for å tilby det store utvalget av data og funksjoner.\n\nHer er hver enkelt forklart:\n\n<b>Kjøre i bakgrunnen når den ikke er aktiv</b> – nødvendig for å oppdatere tidevann/vær fra tredjepartsleverandører sammen med internett-tillatelsen\n\n<b>Sende/motta informasjon til/fra internett</b> – nødvendig for å oppdatere tidevann/vær sammen med bakgrunnskjøring.\n\n<b>Les og vis data fra andre apper.</b> – Andre apper må eksplisitt dele data som urskiver kan lese. Dette inkluderer Garmin-apper som Stress eller Body Battery, som kan oppdateres i sanntid. Uautorisert data fra andre apper kan ikke leses.\n\n<b>GPS-posisjon</b> – nødvendig for soloppgang/solnedgang, måneoppgang/månenedgang og riktig værposisjon\n\n<b>Puls, barometer, temperatur og høydehistorikk</b> – data som vises på urskiven – kun til visning.\n\n<b>Garmin Connect™-treningsprofilen din</b> – nødvendig for vekt, aktive kalorier og energisparing til innstilte søvntider.\n\nIngen personopplysninger som navn eller adresser kan leses ut av urskiver.\n\nDessverre kan ikke tillatelsene settes etter hvordan du bruker urskiven – de kreves alltid."
            },
            "proFeatures": {
                "question": "Hva betyr ♛, og hvorfor viser noen visninger «key»?",
                "answer": "♛ markerer pro-funksjonene på denne urskiven. Etter 5 dagers prøveperiode kan du kjøpe en aktiveringsnøkkel.\n\n«key?» betyr at prøveperioden er over."
            },
            "temperatureUnits": {
                "question": "Hvordan endrer jeg temperaturenheter?",
                "answer": "Gå til klokkens systeminnstillinger (langt trykk på menyknappen): System -> Format -> Enheter, og endre der."
            },
            "timeFormat": {
                "question": "Hvordan setter jeg 12t/24t-format?",
                "answer": "Gå til klokkens systeminnstillinger (langt trykk på menyknappen): System -> Format -> Tidsformat, og endre der."
            },
            "distanceUnits": {
                "question": "Hvordan endrer jeg enheter for avstand eller høyde?",
                "answer": "Gå til klokkens systeminnstillinger (langt trykk på menyknappen): System -> Format -> Enheter, og endre der."
            }
        }
    },
    "helpCenter": {
        "title": "Hjelp og instruksjoner",
        "subtitle": "Finn svar, veiledninger og instruksjoner for urskiven din",
        "guidesTitle": "Veiledninger",
        "faqTitle": "Ofte stilte spørsmål",
        "allCategories": "Alle",
        "guides": "Veiledninger",
        "faqResults": "FAQ",
        "noResults": "Ingen resultater funnet",
        "noResultsHint": "Prøv andre søkeord eller bla gjennom kategoriene og veiledningene nedenfor."
    },
    "guides": {
        "backToHelp": "Tilbake",
        "purchase": {
            "title": "Kjøp og installasjon",
            "tabs": {
                "installation": "Installasjon",
                "versions": "VX / Elite-versjoner",
                "troubleshooting": "Feilsøking"
            },
            "installation": {
                "title": "Installer urskiver via ConnectIQ-appen",
                "intro": "Urskiver kan installeres på klokken via Garmin ConnectIQ-appen for Android eller iOS.",
                "step1": "Koble klokken til telefonen via Bluetooth og åpne ConnectIQ-appen på telefonen.",
                "step2": "Gå til siden for urskiven du vil installere.",
                "step3": "Trykk på «Installer»-knappen. Urskiven legges i nedlastingskøen og installeres på klokken.",
                "step4": "Etter installasjon får du en melding i appen eller på klokken, og urskiven er tilgjengelig på enheten.",
                "noteScreen": "Sørg for at telefonskjermen ikke slås av og at ConnectIQ-appen holdes åpen under installasjon og oppdateringer.",
                "selectWatchfaceTitle": "Velge urskive på klokken",
                "selectWatchfaceIntro": "Hvis urskiven er installert men ikke synlig, må du kanskje velge den i klokkens systemmeny.",
                "select1": "Trykk og hold menyknappen på klokken (eller tilsvarende knapp på touch-enheter) for å åpne systemmenyen.",
                "select2": "Gå til «Watch Faces» eller «Display Designs».",
                "select3": "Bla i listen over installerte urskiver med opp/ned-knappene eller touchskjermen.",
                "select4": "Bekreft valgt urskive med knappen øverst til høyre – den er da aktiv på klokken."
            },
            "versions": {
                "title": "VX vs Elite – hva er forskjellen?",
                "sameFeatures": "Teknisk er begge versjonene identiske med samme funksjoner. De skiller seg bare i hvordan de kjøpes og aktiveres.",
                "eliteTitle": "Elite-versjon (Garmin Pay)",
                "elite1": "Egen installasjon av urskiven kjøpt direkte via Garmin Pay i ConnectIQ Store.",
                "elite2": "Elite-versjonen er knyttet til Garmin-kontoen din. Kjøper du en ny klokke, kan du installere Elite-urskiven igjen uten ekstra nøkkel.",
                "elite3": "Garmin Pay støttes ikke på alle klokkemodeller og er ikke tilgjengelig i alle land.",
                "eliteNoKey": "Viktig: Ved kjøp av Elite-versjon via Garmin Pay sendes ingen aktiveringskode. Elite-versjonen låses opp direkte etter kjøp og krever ingen kode.",
                "vxTitle": "VX / nettversjon",
                "vx1": "Kompatibel med flere enheter og ofte tilgjengelig når Garmin Pay ikke støttes.",
                "vx2": "Har en innebygd gratis prøveperiode på flere dager.",
                "vx3": "Etter prøveperioden kan du kjøpe en aktiveringskode på dette nettstedet for å låse opp VX-versjonen (eller pro-funksjoner) permanent.",
                "vx4": "Aktiveringskoden gjelder alltid bare enheten den ble kjøpt for (WatchfaceID).",
                "vx5": "Byttes klokken av Garmin under garanti, kan en ny nøkkel genereres. Kontakt support via kontaktskjemaet i så fall."
            },
            "website": {
                "title": "Kjøp via nettstedet (VX / vanlige versjoner)",
                "step1": "Installer urskiven på klokken først (se fanen Installasjon). WatchfaceID vises først i urskivinnstillingene etter installasjon.",
                "step2": "Åpne urskivinnstillingene (via ConnectIQ-appen eller Garmin Express) og kopier WatchfaceID fra øverste felt.",
                "step3": "Velg tilsvarende urskive på dette nettstedet og skriv inn WatchfaceID i kjøpsskjemaet.",
                "step4": "Fullfør betalingen. Du får aktiveringskoden på e-post og kan skrive den inn i nøkkelfeltet i urskivinnstillingene.",
                "noteNoAutoInstall": "Viktig: Kjøp av aktiveringskode via nettstedet installerer ikke urskiven automatisk på klokken. Installasjonstrinnene over må gjøres manuelt."
            },
            "troubleshooting": {
                "installationTitle": "Installasjonsproblemer (kø / fastlåste oppdateringer)",
                "installationIntro": "Noen ganger mislykkes installasjonen, urskiven blir lenge i køen, eller ConnectIQ-appen viser endeløse oppdateringer.",
                "installationCause": "Dette skyldes vanligvis ConnectIQ-appen eller Garmin-tjenester, ikke urskiven i seg selv.",
                "installationFix1": "Start klokken og ConnectIQ-appen på telefonen på nytt.",
                "installationFix2": "Prøv installasjonen igjen og sørg for at telefonskjermen ikke slås av og at ConnectIQ-appen holdes åpen.",
                "garminPayTitle": "Garmin Pay-kjøp henger på «in progress»",
                "garminPayText": "Hvis et Garmin Pay-kjøp i ConnectIQ Store blir stående på «in progress» lenge, håndteres dette helt av Garmin. Som utvikler har vi ingen innflytelse på Garmin Pay. Kontakt offisiell Garmin-support i så fall.",
                "noKeyTitle": "Jeg fikk ingen aktiveringsnøkkel etter nettkjøp",
                "noKey1": "Sjekk først søppelpostmappen – e-poster med nøkler havner ofte der.",
                "noKey2": "Ofte hindrer en skrivefeil i e-postadressen levering. Finner du ikke e-posten, kontakt oss.",
                "noKey3": "og oppgi e-postadressen (og om mulig WatchfaceID) du brukte ved betaling.",
                "noKeyElite": "Merk: Ved kjøp av Elite-versjon direkte via Garmin Pay i ConnectIQ Store sendes ingen aktiveringskode. Elite-versjonen låses opp umiddelbart etter kjøp og krever ingen kode."
            },
            "contactLink": "Kontaktskjema"
        },
        "timezones": {
            "title": "Tidssoner og UTC-forskyvning",
            "basicsTitle": "Hva er andre og tredje tidssone?",
            "basicsText": "På mange urskiver kan du konfigurere to ekstra tidssoner. De kalles vanligvis «andre tidssone» og «tredje tidssone» og vises i egne felt på urskiven.",
            "offsetTitle": "Konfigurere UTC-forskyvninger",
            "offsetIntro": "I urskivinnstillingene finnes vanligvis et felt der du angir forskyvningene for andre og tredje tidssone i minutter relativt til UTC.",
            "offsetFormat": "Første verdi er forskyvning for andre tidssone, andre verdi for tredje tidssone. Verdiene angis i minutter, atskilt med mellomrom. Plusstegn legges ikke til automatisk – positive verdier skrives uten +.",
            "exampleLabel": "Eksempel:",
            "exampleExplanation": "Her har andre tidssone forskyvning −4,5 timer (−270 minutter) og tredje tidssone +2 timer (+120 minutter), begge relativt til UTC.",
            "changeExample": "Vil du endre andre tidssone til f.eks. +6 timer, må første verdi være 360 (6 × 60). Med eksemplet over blir det:",
            "advancedTitle": "Avanserte alternativer (A/B/C-suffiks)",
            "advancedOptionalHint": "Dette avsnittet er valgfritt. Kun relevant hvis urskiven støtter A/B/C-format-suffiks.",
            "advancedIntro": "Om urskiven støtter disse suffiksene, står det i beskrivelsen over offset-feltet i innstillingene. Ved støtte finner du en beskrivelse som ligner:",
            "advancedExample": "UTC 2. + 3. tidssoneforskyvning i minutter (skill med mellomrom) (bokstaver etter offset: A - 12t-format, B - 24t-format, C - militært format, tom - standard)",
            "advancedNote": "Disse valgfrie bokstavene (A/B/C) styrer visningsformatet for tidssonen på noen urskiver. Bruk dem bare hvis det står i beskrivelsen for urskiven og du trenger annet tidsformat. For de fleste holder numeriske offset uten bokstaver.",
            "exampleSectionTitle": "Steg for steg: Eksempel for ulike byer og formater",
            "exampleIntro": "Eksemplet viser hvordan du setter andre tidssone (f.eks. New York) og tredje tidssone (f.eks. Tokyo), og valgfritt 12t- eller 24t-visning for hver.",
            "exampleStep1Title": "Steg 1: UTC-forskyvning for 2. tidssone",
            "exampleStep1Text": "Velg by eller region for andre tidssone. Regn tidsforskjell til UTC om til minutter. Eksempel: New York (EST, UTC−5) → −300 minutter. Skriv dette som første verdi i innstillingsfeltet.",
            "exampleStep2Title": "Steg 2: UTC-forskyvning for 3. tidssone",
            "exampleStep2Text": "Samme for tredje tidssone. Eksempel: Tokyo (JST, UTC+9) → 540 minutter. Dette er andre verdi, atskilt med mellomrom fra den første.",
            "exampleOnlyOffsets": "Støtter ikke urskiven A/B/C-suffiks, er du ferdig. Skriv inn:",
            "exampleStep3Title": "Steg 3: Valgfritt format-suffiks (A/B/C)",
            "exampleStep3Optional": "Dette steget er valgfritt: Du kan utelate suffiks selv om urskiven støtter dem – da brukes standardformat. For å tvinge 12t, 24t eller militært format per sone, sett bokstaven rett etter offset – ingen mellomrom mellom offset og suffiks.",
            "exampleStep3Text": "Eksempel: 12-timers format for New York (A) og 24-timers for Tokyo (B):",
            "exampleStep3Note": "Uten suffiks brukes urskivens standard (ofte 24t). Om suffiks støttes, står det i beskrivelsen over offset-feltet.",
            "exampleFormatTitle": "Slik vises tid med A, B, C",
            "exampleFormatIntro": "For samme tidspunkt varierer visningen etter format (eksempel: 2. sone New York -300, 3. sone Tokyo 540). Live forhåndsvisning:",
            "zone2": "2. sone",
            "zone3": "3. sone",
            "exampleTableTitle": "Referanse: UTC-forskyvninger for utvalgte byer (minutter)",
            "exampleTableIntro": "Normaltid; sommertid kan avvike. Multipliser timer med 60."
        },
        "switchViews": {
            "title": "Switchviews og geststyring",
            "wordLabel": "bytt visning",
            "basicsTitle": "Hva er Switchviews?",
            "basicsText": "Mange urskiver kan vise ulik informasjon i samme skjermområde. Disse sidene kalles ofte «Switchview» ({{wordLabel}}), «Switchview 2», «Top View 1/2», «Bottom View 1/2» eller lignende i innstillingene.",
            "proNote": "Ofte er disse ekstra visningene pro-funksjoner tilgjengelige i prøveperioden og krever aktiveringskode etterpå.",
            "gestureTitle": "Bytte visning med håndleddsbevegelse",
            "gestureIntro": "På klokker uten kompatibel touchskjerm kan alternative visninger byttes med en andre håndleddsbevegelse.",
            "gestureStep1": "Løft håndleddet som vanlig for å vekke skjermen. Sekunder eller lysere skjerm viser at klokken er aktiv.",
            "gestureStep2": "Gjør samme bevegelse igjen innen noen sekunder (ca. 7) – ikke for brått, men tydelig nok til at klokken registrerer en andre gest.",
            "gestureStep3": "Støtter urskiven Switchviews, bytter konfigurerte områder (f.eks. øverste eller nederste visning) til neste side.",
            "gestureHint": "Skjer ingenting, sjekk innstillingene: noen visninger må tilordnes eksplisitt (f.eks. «Top View 2» / «Bottom View 2»).",
            "touchTitle": "Switchviews på touch-enheter",
            "touchIntro": "På nyere klokker med touch (f.eks. Fenix 7 og nyere) kan visninger ofte også byttes via trykksoner.",
            "touchConfig": "På mange urskiver konfigureres sonene i innstillingene, ofte lenger ned i listen. Typisk er time- og minutt-sifrene eller egne områder på skjermen.",
            "touchHold": "Er en trykkssone satt, bytter langt trykk på siffer/område den tilordnede visningen.",
            "touchMultiple": "Noen urskiver har flere soner – f.eks. én for øvre og én for nedre visning.",
            "touchInfo": "Har en urskive spesielle soner, beskrives de vanligvis på denne nettsiden eller i ConnectIQ Store."
        },
        "findWfId": {
            "title": "Finn WatchfaceID",
            "whatIs": "Hva er WatchfaceID?",
            "whatIsExplanation": "Hver urskive har en egen WatchfaceID per enhet – et 5–6-sifret nummer. Det trengs for kjøp av aktiveringskode eller support.",
            "connectIqTitle": "Via ConnectIQ-appen (anbefalt)",
            "ciq1": "Sørg for at klokken er koblet til telefonen via Bluetooth.",
            "ciq2": "Åpne ConnectIQ-appen på telefonen.",
            "ciq3": "Gå til urskivens side med beskrivelse og bilder. Bruk søk eller «Mine urskiver» under «Enhet» ved behov.",
            "ciq4": "Trykk «Innstillinger» på urskivsiden for å åpne alle innstillinger.",
            "ciq5": "WatchfaceID står i øverste felt. Kopier eller noter nummeret – det trengs ved betaling.",
            "keyEntryTitle": "Skrive inn aktiveringsnøkkel",
            "keyEntryExplanation": "Under WatchfaceID-feltet finner du felt for nøkkel/kode etter betaling. Noen urskiver viser gjenværende prøvetid der – slett det før du skriver inn koden.",
            "garminExpressTitle": "Via Garmin Express (desktop)",
            "ge1": "Installer Garmin Express og koble klokken til datamaskinen.",
            "ge2": "Gå til listen over installerte urskiver.",
            "ge3": "Klikk tre-prikkers-knappen ved urskiven for å åpne innstillinger.",
            "ge4": "Følg samme steg som i ConnectIQ-appen.",
            "geNote": "Merk: ConnectIQ-appen anbefales – noen Garmin Express-versjoner kan gi feil.",
            "zeroId": "WatchfaceID viser 0?",
            "zeroIdExplanation": "Noen ganger vises WatchfaceID som 0. Lagre innstillingene én gang eller start klokken på nytt. Viser den fortsatt 0, fungerer betaling vanligvis likevel."
        },
        "location": {
            "title": "GPS og posisjon",
            "whatIsGpsFix": "Hva er en GPS-fix?",
            "gpsFixExplanation": "En GPS-fix forteller urskiven hvor du er, slik at sol/måne, værposisjon og tidevann beregnes riktig.",
            "howTo": "Slik gjør du en GPS-fix",
            "step1": "Gå på klokken til startskjermen for en aktivitet (f.eks. «Løping»).",
            "step2": "Vent til klokken har GPS-signal (grønn linje/ikon).",
            "step3": "Gå tilbake til urskiven – data oppdateres innen få minutter.",
            "alternative": "Alternativ: telefon-GPS",
            "alternativeExplanation": "Du kan også aktivere GPS på telefonen. Klokken må være koblet via Bluetooth. Metoden er tregere, men fungerer.",
            "requirements": "Krav",
            "req1": "Klokke koblet til telefon via Bluetooth",
            "req2": "Garmin Connect-appen (ikke ConnectIQ) minst i bakgrunnen",
            "req3": "GPS aktivert på telefonen for posisjonsbasert bruk"
        },
        "settings": {
            "tabs": {
                "options": "Datafeltalternativer",
                "change": "Endre innstillinger",
                "troubleshoot": "Feilsøking"
            },
            "title": "Urskivinnstillinger",
            "optionsIntro": "Dette er den generelle listen over alle datafeltalternativer. Klikk på et alternativ for beskrivelse. Merk at ikke alle alternativer finnes på alle urskiver, eller kan ha litt andre navn.",
            "change": {
                "title": "Slik endrer du urskivinnstillinger",
                "intro": "Urskivinnstillinger endres via ConnectIQ-appen på telefonen.",
                "step1": "Koble klokken til telefonen via Bluetooth og åpne ConnectIQ-appen (ikke Connect-appen).",
                "step2": "Gå til urskivens side. Er den ikke installert, installer den først.",
                "step3": "På urskivsiden finner du «Innstillinger» – trykk for å åpne hele listen.",
                "step4": "Her kan du endre datafelt, farger og avanserte alternativer.",
                "step5": "Trykk lagre øverst til høyre for å overføre innstillingene til klokken. Listen lukkes etter lagring.",
                "installLink": "Installasjonsveiledning"
            },
            "troubleshoot": {
                "title": "Feilsøking",
                "cantSave": {
                    "q": "Innstillinger kan ikke lagres – feilmelding vises",
                    "a1": "Noen ganger har Garmin-servere problemer med visse tegn.",
                    "a2": "Tøm feltet for fargetema (hvis det finnes) i innstillingene og lagre igjen – det løser vanligvis problemet."
                },
                "wontOpen": {
                    "q": "Innstillingene åpnes ikke",
                    "a1": "Lukk ConnectIQ-appen helt og start klokken på nytt om nødvendig.",
                    "a2": "Ser du bare «Installer», er urskiven ikke installert på klokken ennå."
                },
                "missingOptions": {
                    "q": "Jeg finner ikke et bestemt innstillingsalternativ",
                    "a": "Ikke alle alternativer finnes på alle enheter. Tilgjengelighet avhenger av klokkemodell og urskive."
                },
                "naValue": {
                    "q": "Et datafelt viser bare «n/a»",
                    "a": "Enheten støtter ikke dette alternativet – ofte fordi modellen er eldre eller mangler hardware (f.eks. barometer, pulsoximeter)."
                }
            }
        },
        "dateFormat": {
            "title": "Egendefinert datoformat (Dato 1 / 2 / 3)",
            "basicsTitle": "Hva er datoformat-feltene?",
            "basicsIntro": "I urskivinnstillingene finnes to felt (eller tre hvis urskiven støtter det) for hvordan Dato 1, Dato 2 og eventuelt Dato 3 vises. Bokstavene du skriver i hvert felt styrer formatet.",
            "notAll": "Dette finnes ikke på alle urskiver.",
            "where": "Feltene for datoformat ligger vanligvis lenger ned i innstillingene, under datafeltalternativene.",
            "codesTitle": "Formatkoder",
            "codesIntro": "Du kan bruke disse bokstavene i formatfeltet. Visningen følger dagens dato.",
            "codeD": "dag i måneden (med ledende null)",
            "codeDText": "dag som tekst (f.eks. mandag)",
            "codeM": "måned numerisk (med ledende null)",
            "codeMText": "måned som tekst",
            "codeY": "år tosifret",
            "codeY4": "år firesifret",
            "codeJ": "juliansk dato (militær)",
            "codeW": "ukenummer",
            "codeO": "måned uten ledende null",
            "codeN": "dag uten ledende null",
            "codeP": "dag i året",
            "exampleHint": "Eksempel: «D, d.M.Y» kan vise «man, 27.02.2026»."
        }
    },
    "newsletter": {
        "title": "Nyhetsbrev",
        "description": "Abonner for oppdateringer om nye urskiver, funksjoner og tilbud.",
        "frequencyHint": "Omtrent én e-post hver annen måned. Du kan melde deg av når som helst.",
        "emailPlaceholder": "Din e-postadresse",
        "subscribe": "Abonner",
        "unsubscribe": "Meld av",
        "subscribeSuccess": "Abonnement vellykket! Sjekk e-posten din.",
        "subscribeError": "En feil oppstod. Prøv igjen senere.",
        "unsubscribeSuccess": "Avmelding vellykket.",
        "unsubscribeError": "En feil oppstod. Prøv igjen senere."
    },
    "contact": {
        "title": "Kontakt",
        "description": "Har du et spørsmål eller trenger support? Send meg en melding.",
        "emailLabel": "E-post",
        "emailPlaceholder": "din@epost.no",
        "deviceLabel": "Enhet (valgfritt)",
        "devicePlaceholder": "f.eks. Fenix 7",
        "watchfaceLabel": "Urskive (valgfritt)",
        "watchfacePlaceholder": "f.eks. Horizon",
        "messageLabel": "Melding",
        "messagePlaceholder": "Din melding …",
        "send": "Send melding",
        "sendAnother": "Send en ny melding",
        "successTitle": "Melding sendt!",
        "successMessage": "Jeg svarer så snart som mulig.",
        "error": "En feil oppstod. Prøv igjen eller send e-post til dev@orcatec.net.",
        "rateLimit": "Maksimalt 2 meldinger per 5 minutter. Prøv igjen senere.",
        "consentNotice": "Ved å sende samtykker du til behandling av data i henhold til vår",
        "guidesIntro": "Har du spørsmål om bestemte funksjoner, kan disse veiledningene allerede ha svaret:",
        "faqIntro": "For mange emner finnes det også detaljerte FAQ:",
        "faqLinkLabel": "Åpne hjelp og instruksjoner",
        "responseTimeNotice": "Vær oppmerksom på at svartid i travle perioder noen ganger kan ta flere dager."
    },
    "refund": {
        "title": "Refusjonspolicy"
    },
    "terms": {
        "title": "Vilkår for bruk"
    },
    "privacy": {
        "title": "Personvernerklæring"
    },
    "footer": {
        "description": "Moderne Garmin-apper med avanserte funksjoner for alle aktiviteter.",
        "tagline": "Moderne Garmin-apper med avanserte funksjoner for alle aktiviteter.",
        "linksTitle": "Lenker",
        "socialsTitle": "Sosiale medier",
        "terms": "Vilkår for bruk",
        "impressum": "Impressum",
        "privacy": "Personvern",
        "refund": "Refusjonspolicy",
        "contact": "Kontakt",
        "rights": "Alle rettigheter reservert.",
        "links": "Lenker",
        "contactDescription": "Spørsmål eller support?",
        "contactLink": "Ta kontakt",
        "copyright": "Orcatec - TitanicTurtle. Alle rettigheter reservert.",
        "garminForums": "Garmin Forums"
    },
    "tides": {
        "title": "Tidevann via Stormglass.io",
        "intro": "Vil du bruke tidevannsfunksjonen på en urskive med stormglass som leverandør, må du registrere deg på nettstedet deres for å få en API-nøkkel som du skriver inn i det aktuelle feltet i urskivinnstillingene.",
        "apiKey": {
            "title": "Kopier API-nøkkel",
            "description": "Når du kopierer API-nøkkelen, sørg for at alle tegn er med (vanligvis over 60) – noen ganger klipper Android/iOS bort en del etter «-»."
        },
        "freePlan": {
            "title": "Gratis plan",
            "description": "Den gratis (stormglass io)-planen gir 10 gratis forespørsler per dag, nok til tidevannsdata for støttede TitanicTurtle-urskiver.",
            "note": "(Hvis urskiven støtter stormglass io som værleverandør og du vil bruke det, kan du trenge en annen abonnementsplan)"
        },
        "dataDownload": {
            "title": "Datanedlasting",
            "description": "Vanligvis lastes tidevannsdata ned for flere dager og oppdateres daglig når telefonen er tilkoblet. Uten internett vises data minst i 3 (Horizon) / 5 (Centurion) dager. (avhenger av urskive/enhet)"
        },
        "initialSetup": {
            "title": "Første oppsett",
            "description": "Når du har skrevet inn stormglass io API-nøkkelen i innstillingene, kan det ta opptil 30 minutter før data lastes ned og er tilgjengelige."
        },
        "locationUpdate": {
            "title": "Posisjonsoppdatering",
            "description": "Endrer du posisjon, sørg for GPS-signal på klokken slik at tidevannsdata oppdateres for den nye posisjonen."
        },
        "requirements": {
            "title": "Krav",
            "bluetooth": "Sørg for at klokken er koblet til telefonen via Bluetooth, og at Connect-appen (ikke Connect IQ) minst kjører i bakgrunnen.",
            "gps": {
                "title": "GPS-fix",
                "description": "Ser du en melding som «GPS?» på klokken, gjør en GPS-fix slik at urskiven kjenner posisjonen din.",
                "steps": {
                    "step1": "Gå til startskjermen for en aktivitet som «Løping» på klokken",
                    "step2": "Vent til klokken har GPS-signal"
                }
            }
        }
    },
    "common": {
        "loading": "Laster …",
        "error": "Feil",
        "retry": "Prøv igjen",
        "back": "Tilbake",
        "close": "Lukk",
        "save": "Lagre",
        "cancel": "Avbryt",
        "confirm": "Bekreft",
        "notFound": "404 – Siden ble ikke funnet"
    },
    "watchfacesOverview": {
        "title": "Alle apper",
        "loading": "Laster urskiver …",
        "error": "Feil ved lasting av urskiver",
        "retry": "Prøv igjen",
        "noWatchfaces": "Ingen urskiver tilgjengelig"
    },
    "detailTabs": {
        "payment": "Betaling",
        "themes": "Temaer",
        "info": "Info",
        "instructions": "Instruksjoner",
        "instructionsIntro": "Alle veiledninger på ett sted:",
        "noThemes": "Ingen fargetemaer for denne urskiven."
    },
    "watchfaceDetail": {
        "loading": "Laster urskive …",
        "error": {
            "notFound": "Urskive ikke funnet",
            "loading": "Feil ved lasting av urskive"
        },
        "backToOverview": "Tilbake til oversikten",
        "goToStore": "Gå til IQ Store",
        "goToTrial": "Prøveversjon",
        "devices": "enheter",
        "info": {
            "title": "Funksjoner",
            "tides": "🌊 Tidevannsinformasjon med automatiske oppdateringer",
            "weather": "🌤️ Værdata fra OpenWeatherMap og Yr",
            "colors": "🎨 Fargetemaer og tilpasninger",
            "location": "📍 GPS-basert posisjonsbestemmelse",
            "faq": "❓ FAQ og support",
            "weatherFallback": "Skrives en OpenWeatherMap API-nøkkel inn uten Once Call 3.0-abonnement, faller systemet tilbake til værleverandøren «Yr»."
        }
    },
    "themeInfo": {
        "howDoThemesWork": {
            "title": "Hvordan fungerer temaer?:",
            "description": "Øverst i urskivinnstillingene har du en «themestring» som representerer gjeldende fargeinnstillinger (ikoner, diagram, tid osv.). Endrer du noe (f.eks. farge på øvre del) og trykker «Lagre», oppdateres themestringen neste gang du åpner innstillingene. Du kan lagre fargevalg ved å kopiere og lagre themestringen et annet sted, dele den (f.eks. i anmeldelser/forum) eller bruke andres themestrings for å prøve nye stiler."
        },
        "dynamicThemeSwitching": {
            "title": "Dynamisk temabytte:",
            "sunset": {
                "title": "Bytte etter solnedgang / før soloppgang -",
                "description": "Setter du et utropstegn ! foran themestringen du vil bytte til i themestring-feltet, lagres den som tema etter solnedgang (eksempel: !UEUE[UEUEEEEEEU^). Du kan endre når som helst med en themestring som starter med !. For å fjerne natt-tema, skriv bare et enkelt ! i feltet – da byttes det ikke lenger."
            },
            "lowPower": {
                "title": "Bytte i lavstrømsmodus -",
                "description": "Samme fremgangsmåte som solnedgang/soloppgang, men bruk # i stedet for ! foran themestringen (eksempel: #UEUE[UEUEEEEEEU^). Klokken går i «lavstrømsmodus» etter ~10 sekunder når du ser på den / kommer tilbake fra en meny. Sekunder forsvinner vanligvis i lavstrøm (kan endres i innstillingene). Begge alternativene kan kombineres. En dynamisk themestring vises ikke i innstillingene når den er satt – lagre den et annet sted hvis du vil endre den senere."
            }
        }
    },
    "colorThemes": {
        "clickToCopy": "Klikk for å kopiere",
        "clickToPreview": "Klikk for forhåndsvisning",
        "closePreview": "Lukk forhåndsvisning",
        "copied": "Kopiert!",
        "useInSettings": "Bruk den i urskivinnstillingene",
        "guideLink": "Mer om temaer og themestrings",
        "deviceNote": "Merk: Fargetemaer er ikke tilgjengelig på alle enheter.",
        "noFieldNote": "Har ikke urskivinnstillingene eget felt for fargetemaer, støttes de ikke for din klokkemodell på denne urskiven."
    },
    "payment": {
        "option1": {
            "title": "Betalingsalternativ 1: Garmin Pay",
            "description": "Kjøp den betalte urskiven direkte via Garmin Pay i ConnectIQ Store (hvis klokken støttes).",
            "link": "Lenke til ConnectIQ Store"
        },
        "option2": {
            "title": "Betalingsalternativ 2: Direkte betaling via WatchfaceID",
            "description": "Støttes ikke klokken av den betalte pro-versjonen, kan du kjøpe en prøve/VX-nøkkel ved å skrive inn WatchfaceID.",
            "vxNote": "Dette er en nøkkel for VX-versjonen av urskiven, ikke Garmin Pay-versjonen!",
            "vxLink": "Lenke til VX-versjon"
        },
        "tax": "mva.",
        "wfid": {
            "description": "Skriv inn WatchfaceID (finnes i urskivinnstillingene)",
            "placeholder": "Skriv inn WatchfaceID (5–6 siffer)",
            "guideLink": "Hvordan finner jeg WatchfaceID?",
            "guideLinkShort": "Vis veiledning"
        },
        "wfidError": {
            "letters": "WatchfaceID skal bare inneholde tall",
            "tooLong": "WatchfaceID skal være 5–6 siffer",
            "invalid": "Skriv inn en gyldig WatchfaceID (5–6 siffer)",
            "lengthHint": "WatchfaceID er vanligvis 5–6 siffer. Dobbeltsjekk."
        },
        "errors": {
            "empty": "Skriv inn WatchfaceID",
            "invalid": "Skriv inn en gyldig WatchfaceID",
            "config": "Feil i betalingskonfigurasjon",
            "checkout": "Kunne ikke åpne kasse. Prøv igjen."
        },
        "buy": "Kjøp nå",
        "selectMethod": "Velg versjon",
        "versionSelectHint": "Dette er to separate versjoner — velg riktig:",
        "vxWarning": "VX- og Elite-versjonene er hver for seg nedlastbare versjoner av urskiven. En aktiveringskode for VX låser IKKE opp Elite-versjonen.",
        "beta": {
            "title": "For tiden i beta",
            "description": "I denne betafasen kan du bruke urskiven helt gratis. Det kommer ingen automatiske kostnader etter testfasen. Nye funksjoner testes nå. Takk for tilbakemeldinger!",
            "descriptionApp": "I denne betafasen kan du bruke appen helt gratis. Etter testperioden kommer det ingen automatiske kostnader. I denne fasen testes nye funksjoner. Takk for tilbakemeldingene!"
        },
        "elite": {
            "badge": "Garmin Pay",
            "title": "Elite-versjon",
            "description": "Denne urskiven er kun tilgjengelig via Garmin Pay i ConnectIQ Store.",
            "comboDescription": "Kjøp direkte via Garmin Pay i ConnectIQ Store. Dette er en separat, frittstående versjon.",
            "compatibility": "Merk: Ikke alle klokkemodeller støtter Garmin Pay. Sjekk kompatibilitet på storesiden. Ellers last ned VX-versjonen (teknisk identisk).",
            "storeLink": "Åpne i ConnectIQ Store",
            "moreGuide": "Mer om forskjellen mellom Elite- og VX-versjon?",
            "moreGuideLink": "Les kjøps- og installasjonsveiledningen",
            "eliteNoKey": "Ved kjøp av Elite via Garmin Pay sendes ingen aktiveringskode. Elite låses opp direkte etter kjøp og krever ingen kode.",
            "accountBound": "Kjøp via Garmin Pay er knyttet til Garmin-kontoen din og tilgjengelig på fremtidige enheter (hvis kompatible).",
            "eliteNoKeyAndGuide": "Ved kjøp via Garmin Pay sendes ingen aktiveringskode — Elite låses opp direkte etter kjøp. Mer i kjøps- og installasjonsveiledningen."
        },
        "vx": {
            "badge": "Alle enheter",
            "title": "VX-versjon",
            "description": "Kompatibel med alle støttede enheter. Last ned gratis prøveversjon fra ConnectIQ Store og aktiver her med kjøpt kode.",
            "trialNote": "VX-versjonen har gratis prøveperiode. Etter prøven kan du kjøpe aktiveringskode nedenfor for permanent opplåsing.",
            "deviceBound": "En aktiveringskode er knyttet til enheten og låser opp VX permanent.",
            "moreGuide": "Mer om VX, nøkler eller installasjon?",
            "moreGuideLink": "Les kjøps- og installasjonsveiledningen",
            "downloadLink": "Last ned VX-versjon",
            "details": {
                "line1": "Etter vellykket betaling sendes aktiveringsnøkkelen til e-postadressen du oppgir i neste steg.",
                "line2": "Sørg for at e-postadressen er riktig.",
                "line3": "Sjekk søppelpost etter betaling – nøkkel-e-poster havner ofte der.",
                "line4": "Alle betalingsalternativer håndteres av Paddle – ingen konto nødvendig.",
                "line5": "For support, bruk kontaktskjemaet eller ConnectIQ Store-verktøyet.",
                "line6": "Andre henvendelser kan ikke behandles."
            }
        },
        "standalone": {
            "title": "Kjøp aktiveringskode",
            "description": "Kjøp aktiveringskode ved å skrive inn WatchfaceID nedenfor. Koden sendes med en gang."
        },
        "checkoutOpening": "Åpner kasse …",
        "info": {
            "key": "Etter kjøp får du en nøkkel du kan skrive inn i urskivinnstillingene.",
            "activation": "Nøkkelen aktiveres umiddelbart etter vellykket betaling.",
            "support": "Har du spørsmål, kontakt support.",
            "moreGuide": "Mer om kjøp og installasjon"
        },
        "methods": {
            "applePay": "Apple Pay",
            "googlePay": "Google Pay",
            "alipay": "Alipay",
            "paypal": "PayPal",
            "creditCard": "Kredittkort"
        }
    },
    "fonts": {
        "title": "Skrifttyper",
        "timefonts": "Tidsskrifter",
        "datafonts": "Dataskrifter"
    },
    "weather": {
        "title": "Værdataleverandører",
        "intro": "På mange urskiver kan du velge ulike værdataleverandører på de fleste enheter. Leverandør endres i ConnectIQ-appens innstillinger for urskiven. Som standard er ofte Garmin-vær eller Yr valgt.",
        "noData": "Viser et værdatafelt «no data», ble ingen værdata lastet. Nedenfor finner du steg for å få værdata på klokken.",
        "tabs": {
            "garmin": "Garmin",
            "yr": "Yr",
            "openweathermap": "OpenWeatherMap",
            "visualcrossing": "Visual Crossing",
            "location": "Posisjon"
        },
        "garmin": {
            "title": "Bruke Garmin-vær:",
            "description": "Støtter enheten Garmin-vær, koble klokken til telefonen via Bluetooth og sørg for at Connect-appen (ikke Connect IQ) minst kjører i bakgrunnen med tilgang til telefonens posisjon. (GPS-posisjon må være på)",
            "download": "Klokken laster da værdata fra tjenesten automatisk – kan ta noen minutter.",
            "check": "Sjekk om Garmin-vær-widgeten på klokken allerede viser data. Uten data der kan ikke urskiven vise noe heller – samme datakilde.",
            "noApiKey": "Ingen ekstra API-nøkkel trengs for Garmin-vær.",
            "location": "På noen urskiver vises også medfølgende posisjon med Garmin-vær. Garmin-stasjoner er ofte nærmeste flyplass – mer presis plassering krever andre leverandører.",
            "update": "Posisjon oppdateres når posisjonsdata er aktive på telefonen.",
            "noData": "Kan ikke værdata vises eller oppdateres, vises «no data» -> følg stegene over.",
            "missingData": {
                "title": "Data som ikke finnes i Garmin-vær:",
                "airQuality": "Luftkvalitet",
                "uvIndex": "UV-indeks",
                "description": "Værbeskrivelse"
            }
        },
        "yr": {
            "title": "Bruke Yr:",
            "description": "Yr leveres av Meteorologisk institutt og NRK og kan brukes uten API-nøkkel.",
            "setup": "For værdata fra Yr, velg det som leverandør og koble klokken til telefonen via Bluetooth.",
            "connectApp": "På telefonen: Connect-appen (ikke ConnectIQ) minst i bakgrunnen – klokken henter bl.a. værdata via den.",
            "interval": "Har urskiven oppdateringsintervall, er minimum 10 minutter med Yr som leverandør.",
            "noData": {
                "title": "no data / feil posisjon:",
                "description": "Lastes ikke værdata eller er posisjonen feil, oppdater lagret posisjon for urskiven.",
                "fix": "Gå på klokken til startskjerm for en aktivitet som «Løping» og vent på GPS-signal. Vær/posisjon oppdateres innen minutter."
            },
            "missingData": {
                "title": "Data som ikke finnes i Yr:",
                "airQuality": "Luftkvalitet"
            }
        },
        "openweathermap": {
            "title": "Bruke OpenWeatherMap:",
            "description": "Støtter urskiven OpenWeatherMap og du vil bruke det, trenger du en gratis API-nøkkel fra nettstedet deres:",
            "setup": "Når du har nøkkelen, skriv den inn i feltet i urskivinnstillingene. (Ny nøkkel kan ta noen timer før den virker)",
            "connect": "Koble klokken til telefonen via Bluetooth og la Connect-appen (ikke Connect IQ) minst kjøre i bakgrunnen for nedlasting av værdata.",
            "gps": "Ser du «GPS?» på klokken, gjør en GPS-fix. (Gå til startskjerm for aktivitet som «Løping» og vent på GPS-signal)",
            "uv": {
                "title": "UV-indeks / nedbør på OpenWeatherMap:",
                "oldKey": "Har du eldre API-nøkkel (før ~feb. 2023), kan du bruke disse verdiene uten problemer.",
                "newKey": "Er nøkkelen nyere og du vil se disse verdiene fra OpenWeatherMap, kan du trenge gratis abonnement «One Call by Call».",
                "limit": "De første 1000 forespørslene per dag er i praksis gratis; sett grense til 1000 – mer enn nok for værdata hele dagen på mine urskiver."
            },
            "select": "Støtter urskiven flere tredjepartsleverandører, velg OpenWeatherMap i nedtrekksmenyen i innstillingene."
        },
        "visualcrossing": {
            "title": "Bruke Visual Crossing:",
            "description": "Vil du bruke Visual Crossing, hent en gratis API-nøkkel på nettstedet deres.",
            "setup": "Skriv nøkkelen inn i feltet i urskivinnstillingene og velg Visual Crossing som leverandør i menyen.",
            "connect": "Koble klokken til telefonen via Bluetooth og la Connect-appen (ikke Connect IQ) minst kjøre i bakgrunnen.",
            "gps": "Ser du «GPS?» på klokken, gjør en GPS-fix. (Gå til startskjerm for aktivitet som «Løping» og vent på GPS-signal)"
        },
        "location": {
            "title": "Posisjonsoppdatering",
            "description": "For riktig værvisning trenger urskiven din nåværende posisjon, bestemt via GPS.",
            "gpsFix": {
                "title": "Gjør GPS-fix:",
                "description": "Ser du «GPS?» på klokken, må du gjøre en GPS-fix slik at urskiven kjenner posisjonen.",
                "step1": "Gå på klokken til startskjerm for en aktivitet som «Løping»",
                "step2": "Vent til klokken har GPS-signal",
                "step3": "Gå tilbake til urskiven – værdata oppdateres innen minutter"
            },
            "requirements": {
                "title": "Krav:",
                "bluetooth": "Klokken må være koblet til telefonen via Bluetooth",
                "connectApp": "Connect-appen (ikke Connect IQ) må minst kjøre i bakgrunnen",
                "gps": "GPS må være aktivert på telefonen"
            }
        }
    },
    "bierwander": {
        "title": "Bierwandern",
        "intro": "Bierwandern-appen lar deg spore turen og påfyllene du nyter underveis. I tillegg finnes et promille-estimat med diagram (grovt anslag) – men ta det ikke for alvorlig!",
        "settingsHint": "På startskjermen trykker du på meneknappen på klokken for å åpne innstillinger (på klokker med 2-knapps layout: trykk lenge på berøringsskjermen).",
        "disclaimer": "Promille-beregningen er ren moro – en algoritme som anslår alkohol i blodet basert på inntatt drikke og kroppsvekt! Ikke ta beslutninger basert på denne verdien – den er ikke pålitelig og er ikke en ekte alkoholmåling!",
        "closing": "Ellers ønsker jeg deg gode turer og god stemning!",
        "support": "Ved problemer eller forbedringsforslag, bruk «App Support»-knappen – takk."
    },
    "bodysurf": {
        "intro": {
            "title": "Hva er BodySurf?",
            "text": "BodySurf er en Garmin Connect IQ-klokkeapp for bodysurfing. Den bruker GPS til å oppdage når du rir en bølge, måler distanse og varighet for hver tur og gir en morsom tittel basert på distansen. Økter lagres som aktiviteter med individuelle runder i Garmin Connect."
        },
        "gps": {
            "title": "Før du starter – GPS",
            "text1": "Vent på GPS-fix før du starter en økt. På startskjermen vises «Søker GPS» til signal er tilgjengelig, deretter «START for å begynne».",
            "text2": "For best nøyaktighet bruker appen multi-GNSS / dual-band GPS når klokken støtter det. Stå stille et øyeblikk ved vannet hvis fixen tar tid."
        },
        "start": {
            "title": "Start skjerm",
            "startBtn": "Start en ny økt når GPS er klar (START = begynn økt).",
            "menuBtn": "Åpne innstillinger: Hvordan bruke og Enheter (MENY = innstillinger / info).",
            "backBtn": "BAK = avslutt app"
        },
        "during": {
            "title": "Under aktivitet",
            "detect": "Ritt blir oppdaget av GPS hastighet automatisk. Bruk BAK for å starte/stopp et ritt manuelt. Korte bevegelser under ca. 2 meter forkastes.",
            "startBtn": "START = stopp / lagre / fortsett",
            "backBtn": "BAK = manuell ritt på/av",
            "live": "Under riding ser du nåværende distanse, live-tittel og «RIDING!». Etter en tur forblir tittel og statistikk synlig til neste tur."
        },
        "stop": {
            "title": "Stoppmeny",
            "resume": "Fortsett",
            "save": "Lagre",
            "discard": "Forkast"
        },
        "after": {
            "title": "Etter økt",
            "summary": "Oppsummeringen viser økttid, antall Ritt, total distanse og Best tur med tittel og statistikk.",
            "rides": "Sveip for å se ritt detaljer. På knappeklokker: << DOWN rides.",
            "finished": "Deretter: Ny økt med START eller Avslutt app med TILBAKE."
        },
        "titles": {
            "title": "Tur-titler",
            "intro": "Hvert ritt får en morsom tittel basert på distanse. Jo lengre rittet er, jo bedre tittel!",
            "colDistance": "Distanse",
            "colTitle": "Tittel",
            "th0": "Strandgods",
            "th1": "Sjøpølse",
            "th2": "Flyndre",
            "th3": "Måkeskremmer",
            "th4": "Kystsheriff",
            "th5": "Inspektør",
            "th6": "Bølgerytter",
            "th7": "Rådgiver",
            "th8": "Bølgebryter",
            "th9": "Aquaman",
            "th10": "Menneskelig surfebrett",
            "th11": "Kystlegende",
            "th12": "Poseidon"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "Lagrede økter vises i Garmin Connect med egne felt: tur-tittel, runde-distanse (meter), runde-tid (sekunder) og lengste tur/tid på øktnivå. Hver oppdaget tur lagres som en runde."
        },
        "instinct": {
            "title": "Instinct 2 / 3 (MIP)",
            "layout": "På Instinct viser subdisplay tid, GPS og tur-distanse. Bruk NED-knappen i stedet for sveip (<< DOWN rides).",
            "menu": "«Meny» vises til venstre på startskjermen. Trykk START når GPS OK vises i subdisplay."
        },
        "settings": {
            "title": "Innstillinger",
            "units": "Enheter: bytt mellom metrisk og imperial for distanse og hastighet på klokken.",
            "info": "Info: innebygd hjelp (Hvordan bruke) for knapper under aktivitet, etter økt og på startskjermen."
        },
        "supportBefore": "Ved problemer eller forslag bruk",
        "supportLink": "kontaktskjemaet",
        "supportAfter": " – takk!"
    }
};
